export default __webpack_public_path__ + "static/media/2324 knife block B side.4c3a68d1.png";